webpackJsonp([119366120044],{

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AudienceDropDown = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(6);
	
	var _resourceLibraryManager = __webpack_require__(74);
	
	var _audienceFilter = __webpack_require__(933);
	
	var _styles = __webpack_require__(931);
	
	var _audienceIcon = __webpack_require__(105);
	
	var _audienceIcon2 = _interopRequireDefault(_audienceIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AudienceDropDownComponent = function (_React$PureComponent) {
		_inherits(AudienceDropDownComponent, _React$PureComponent);
	
		function AudienceDropDownComponent() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, AudienceDropDownComponent);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				open: false
			}, _this.close = function () {
				_this.setState({
					open: false
				});
			}, _this.open = function () {
				_this.setState(function (prevState) {
					return {
						open: !prevState.open
					};
				});
			}, _this.onChange = function (audience) {
				_this.props.onChange(audience);
				_this.close();
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		AudienceDropDownComponent.prototype.render = function render() {
			var open = this.state.open;
			var _props = this.props,
			    value = _props.value,
			    className = _props.className;
	
			return _react2.default.createElement(
				'div',
				{ className: (0, _emotion.cx)(_styles.componentWrapStyle, className) },
				_react2.default.createElement(
					'button',
					{ onClick: this.open, className: (0, _styles.componentInnerStyle)(open) },
					_react2.default.createElement(_audienceIcon2.default, { audience: { id: value }, size: 12 }),
					_react2.default.createElement(
						'span',
						null,
						_resourceLibraryManager.audienceTitles[value] || 'All Resources'
					)
				),
				open && _react2.default.createElement(
					_react2.default.Fragment,
					null,
					_react2.default.createElement('div', { className: _styles.backdropStyle, onClick: this.close }),
					_react2.default.createElement(
						'div',
						{ className: _styles.componentDropDownStyle },
						_react2.default.createElement(_audienceFilter.AudienceFilter, { activeAudience: value, onChange: this.onChange })
					)
				)
			);
		};
	
		return AudienceDropDownComponent;
	}(_react2.default.PureComponent);
	
	AudienceDropDownComponent.propTypes = {
		value: _propTypes2.default.string.isRequired,
		onChange: _propTypes2.default.func.isRequired,
		className: _propTypes2.default.string
	};
	
	var AudienceDropDown = exports.AudienceDropDown = AudienceDropDownComponent;

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(929);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.backdropStyle = exports.componentDropDownStyle = exports.componentInnerStyle = exports.componentWrapStyle = undefined;
	
	var _css;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _dropDownGreyIcon = __webpack_require__(762);
	
	var _dropDownGreyIcon2 = _interopRequireDefault(_dropDownGreyIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentWrapStyle = /*#__PURE__*/exports.componentWrapStyle = (0, _emotion.css)({
		position: 'relative'
	});
	
	var height = 46;
	
	var componentInnerStyle = exports.componentInnerStyle = function componentInnerStyle(active) {
		return (/*#__PURE__*/(0, _emotion.css)({
				width: '100%',
				height: height,
				padding: '0 15px',
				display: 'flex',
				justifyContent: 'flex-start',
				alignItems: 'center',
				borderRadius: '4px',
				border: '1px solid ' + _globalStyles.lightGrey,
				background: '#f4f4f4',
				cursor: 'pointer',
				outline: 'none',
	
				'&:after': {
					content: "''",
					display: 'block',
					width: '14px',
					height: '9px',
					position: 'absolute',
					top: '50%',
					right: '15px',
					transform: 'translateY(-50%)' + (active ? ' scaleY(-1)' : ''),
					background: 'url(' + _dropDownGreyIcon2.default + ') no-repeat center'
				},
	
				'& > span': {
					marginLeft: '20px',
					fontSize: '14px',
					color: '#000',
					fontWeight: 500
				}
			})
		);
	};
	
	var componentDropDownStyle = /*#__PURE__*/exports.componentDropDownStyle = (0, _emotion.css)((_css = {
		position: 'absolute',
		top: height + 10,
		zIndex: 10
	
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		width: '100%'
	}, _css));
	
	var backdropStyle = /*#__PURE__*/exports.backdropStyle = (0, _emotion.css)({
		position: 'fixed',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 9
	});

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.AudienceFilter = AudienceFilter;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resourceLibraryManager = __webpack_require__(74);
	
	var _styles = __webpack_require__(934);
	
	var _audienceIcon = __webpack_require__(105);
	
	var _audienceIcon2 = _interopRequireDefault(_audienceIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audiencesData = [''].concat(_resourceLibraryManager.audiences).map(function (audience) {
	  var a = {
	    id: audience,
	    title: _resourceLibraryManager.audienceTitles[audience] || 'All Resources'
	  };
	  return _extends({}, a, {
	    icon: _react2.default.createElement(_audienceIcon2.default, { audience: a, size: 12 })
	  });
	});
	
	function AudienceFilter(_ref) {
	  var activeAudience = _ref.activeAudience,
	      onChange = _ref.onChange;
	
	  function onClick(id) {
	    return function (e) {
	      e.preventDefault();
	      onChange(id);
	    };
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: _styles.wrapperStyle },
	    audiencesData.map(function (audience) {
	      return _react2.default.createElement(
	        'div',
	        { key: audience.id, onClick: onClick(audience.id), className: (0, _styles.itemStyle)(audience.id === activeAudience) },
	        audience.icon,
	        _react2.default.createElement(
	          'span',
	          null,
	          audience.title
	        )
	      );
	    })
	  );
	};
	
	AudienceFilter.propTypes = {
	  activeAudience: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired
	};

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(932);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.itemStyle = exports.wrapperStyle = undefined;
	
	var _css;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)((_css = {
		width: 255,
		overflow: 'hidden',
		borderRadius: 6,
		boxShadow: '0 10px 15px 5px rgba(0,0,0,0.2)'
	
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		width: '100%',
		flexGrow: 1,
		marginRight: 0
	}, _css));
	
	var itemStyle = exports.itemStyle = function itemStyle(active) {
		var _css2;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css2 = {
				height: 54,
				padding: '0 22px',
				display: 'flex',
				justifyContent: 'flex-start',
				alignItems: 'center',
				backgroundColor: active ? '#f4f4f4' : '#fff',
				cursor: 'pointer'
	
			}, _css2['&:hover'] = {
				backgroundColor: '#f4f4f4'
			}, _css2['& > span'] = {
				marginLeft: 20,
				fontSize: 14,
				color: '#000',
				fontWeight: 500
			}, _css2))
		);
	};

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LandingBlock = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resourceLibraryManager = __webpack_require__(74);
	
	var _navManager = __webpack_require__(22);
	
	var _link = __webpack_require__(9);
	
	var _cards = __webpack_require__(17);
	
	var _eLearningCard = __webpack_require__(246);
	
	var _resourceCard = __webpack_require__(30);
	
	var _inPagePrompt = __webpack_require__(376);
	
	var _resourceLibrary = __webpack_require__(487);
	
	var _arrowIcon = __webpack_require__(171);
	
	var _arrowIcon2 = _interopRequireDefault(_arrowIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resourcePropType = _propTypes2.default.shape({
	  edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    node: _propTypes2.default.shape({
	      id: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      date: _propTypes2.default.string,
	      fields: _propTypes2.default.shape({
	        thumbnail_image: _propTypes2.default.shape({
	          childImageSharp: _propTypes2.default.shape({
	            resize: _propTypes2.default.shape({
	              src: _propTypes2.default.string.isRequired
	            }).isRequired
	          }).isRequired
	        }).isRequired
	      }),
	      attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        vimeo_url: _propTypes2.default.string
	      }))
	    }).isRequired
	  }).isRequired)
	});
	
	var ELearnings = function ELearnings(_ref) {
	  var data = _ref.data,
	      onViewAll = _ref.onViewAll;
	  return _react2.default.createElement(
	    'section',
	    { className: _resourceLibrary.sectionStyle },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: _resourceLibrary.subTitleStyle },
	        'eLearning'
	      ),
	      _react2.default.createElement(
	        _link.Link,
	        {
	          to: (0, _resourceLibraryManager.linkWithQueryParams)((0, _resourceLibraryManager.queryParamsFromFilters)({ audience: 'professionals', type: 'elearning' })),
	          onClick: function onClick() {
	            return onViewAll({ audience: 'professionals', type: 'elearning' });
	          } },
	        'View all ',
	        _react2.default.createElement(_arrowIcon2.default, { fill: 'inherit' })
	      )
	    ),
	    _react2.default.createElement(
	      _cards.Cards,
	      { columns: 1, scrollable: false },
	      data.edges.map(function (_ref2, index) {
	        var node = _ref2.node;
	        return _react2.default.createElement(_eLearningCard.ELearningCard, {
	          to: (0, _navManager.idToLink)(node.id),
	          key: index,
	          fullWidth: true,
	          hasVideo: !!node.attachments.find(function (a) {
	            return a.vimeo_url;
	          }),
	          mediaImage: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src,
	          title: node.title,
	          body: node.extract,
	          linkText: node.tile_button_text || 'Watch the Demo' });
	      })
	    )
	  );
	};
	ELearnings.propTypes = {
	  data: resourcePropType.isRequired,
	  onViewAll: _propTypes2.default.func.isRequired
	};
	
	var AudienceSection = function AudienceSection(_ref3) {
	  var data = _ref3.data,
	      audience = _ref3.audience,
	      onViewAll = _ref3.onViewAll;
	
	  if (data == null || !Array.isArray(data.edges) || data.edges.length < 1) return null;
	  return _react2.default.createElement(
	    'section',
	    { className: _resourceLibrary.sectionStyle },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: _resourceLibrary.subTitleStyle },
	        _resourceLibraryManager.audienceTitles[audience]
	      ),
	      _react2.default.createElement(
	        _link.Link,
	        {
	          to: (0, _resourceLibraryManager.linkWithQueryParams)((0, _resourceLibraryManager.queryParamsFromFilters)({ audience: audience, type: _resourceLibraryManager.categories[audience][0] })),
	          onClick: function onClick() {
	            return onViewAll({ audience: audience, type: _resourceLibraryManager.categories[audience][0] });
	          } },
	        'View all ',
	        _react2.default.createElement(_arrowIcon2.default, { fill: 'inherit' })
	      )
	    ),
	    _react2.default.createElement(
	      _cards.Cards,
	      { columns: 4 },
	      data.edges.map(function (_ref4, index) {
	        var node = _ref4.node;
	        return _react2.default.createElement(_resourceCard.ResourceCard, {
	          key: index,
	          id: node.id,
	          to: (0, _navManager.idToLink)(node.id),
	          background: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src,
	          audiences: (0, _resourceLibraryManager.extractAudiences)(node.categories),
	          hasVideo: !!node.attachments.find(function (a) {
	            return a.vimeo_url;
	          }),
	          title: node.title,
	          body: node.extract,
	          date: node.date });
	      })
	    )
	  );
	};
	AudienceSection.propTypes = {
	  data: resourcePropType.isRequired,
	  audience: _propTypes2.default.string.isRequired,
	  onViewAll: _propTypes2.default.func.isRequired
	};
	
	var LandingBlock = exports.LandingBlock = function LandingBlock(_ref5) {
	  var data = _ref5.data,
	      page = _ref5.page,
	      onSectionSelect = _ref5.onSectionSelect;
	  var recentELearnings = data.recentELearnings,
	      recentForMe = data.recentForMe,
	      recentForCarers = data.recentForCarers,
	      recentForResearchers = data.recentForResearchers,
	      recentForServiceDevelopment = data.recentForServiceDevelopment;
	
	  var pageSettings = page.edges[0].node;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    recentELearnings && _react2.default.createElement(ELearnings, { data: recentELearnings, onViewAll: onSectionSelect }),
	    recentForMe && _react2.default.createElement(AudienceSection, { data: recentForMe, audience: 'me', onViewAll: onSectionSelect }),
	    recentForCarers && _react2.default.createElement(AudienceSection, { data: recentForCarers, audience: 'carers', onViewAll: onSectionSelect }),
	    _react2.default.createElement(_inPagePrompt.InPagePrompt, {
	      topText: pageSettings.purple_heading,
	      bottomText: pageSettings.purple_body,
	      cta: { to: pageSettings.button_to, text: pageSettings.button_text },
	      inline: true }),
	    recentForResearchers && _react2.default.createElement(AudienceSection, { data: recentForResearchers, audience: 'researchers', onViewAll: onSectionSelect }),
	    recentForServiceDevelopment && _react2.default.createElement(AudienceSection, { data: recentForServiceDevelopment, audience: 'service_development', onViewAll: onSectionSelect })
	  );
	};
	
	LandingBlock.propTypes = {
	  data: _propTypes2.default.shape({
	    recentELearnings: resourcePropType.isRequired,
	    recentForMe: resourcePropType.isRequired,
	    recentForCarers: resourcePropType.isRequired,
	    recentForResearchers: resourcePropType.isRequired,
	    recentForServiceDevelopment: resourcePropType
	  }).isRequired,
	  page: _propTypes2.default.shape({
	    edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      node: _propTypes2.default.shape({
	        purple_heading: _propTypes2.default.string.isRequired,
	        purple_body: _propTypes2.default.string.isRequired,
	        button_text: _propTypes2.default.string.isRequired,
	        button_to: _propTypes2.default.string.isRequired
	      }).isRequired
	    })).isRequired
	  }).isRequired,
	  onSectionSelect: _propTypes2.default.func
	};

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(935);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ResultsBlock = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _navManager = __webpack_require__(22);
	
	var _resourceLibraryManager = __webpack_require__(74);
	
	var _cards = __webpack_require__(17);
	
	var _resourceCard = __webpack_require__(30);
	
	var _inPagePrompt = __webpack_require__(376);
	
	var _pagination = __webpack_require__(78);
	
	var _resourceLibrary = __webpack_require__(487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeCard = function NodeCard(_ref) {
	  var node = _ref.node;
	  return _react2.default.createElement(_resourceCard.ResourceCard, {
	    id: node.id,
	    to: (0, _navManager.idToLink)(node.id),
	    background: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src,
	    audiences: (0, _resourceLibraryManager.extractAudiences)(node.categories),
	    hasVideo: !!node.attachments.find(function (a) {
	      return a.vimeo_url;
	    }),
	    title: node.title,
	    body: node.extract,
	    date: node.date });
	};
	
	var ResultsBlock = exports.ResultsBlock = function ResultsBlock(_ref2) {
	  var data = _ref2.data,
	      page = _ref2.page,
	      filters = _ref2.filters,
	      _onPageChange = _ref2.onPageChange;
	  var totalResources = data.totalResources,
	      totalPages = data.totalPages,
	      nodes = data.nodes;
	
	  var pageSettings = page.edges[0].node;
	  var isEmpty = totalResources < 1;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _resourceLibrary.pageControlsStyle },
	      !isEmpty && _react2.default.createElement(
	        'p',
	        null,
	        totalResources,
	        ' resource',
	        totalResources > 1 ? 's' : ''
	      ),
	      isEmpty && _react2.default.createElement(
	        'p',
	        null,
	        '0 results'
	      )
	    ),
	    isEmpty && _react2.default.createElement(
	      'section',
	      { className: _resourceLibrary.sectionStyle },
	      _react2.default.createElement(
	        'header',
	        null,
	        _react2.default.createElement(
	          'h1',
	          { className: _resourceLibrary.subTitleStyle },
	          'There are currently no resources within this selection.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Try changing your search criteria, or view all resources.'
	      )
	    ),
	    !isEmpty && _react2.default.createElement(
	      'section',
	      { className: _resourceLibrary.sectionStyle },
	      _react2.default.createElement(
	        _cards.Cards,
	        null,
	        nodes.slice(0, 9).map(function (node) {
	          return _react2.default.createElement(NodeCard, { node: node, key: node.id });
	        })
	      )
	    ),
	    !isEmpty && _react2.default.createElement(_inPagePrompt.InPagePrompt, {
	      topText: pageSettings.purple_heading,
	      bottomText: pageSettings.purple_body,
	      cta: {
	        to: pageSettings.button_to,
	        text: pageSettings.button_text
	      },
	      inline: true }),
	    !isEmpty && _react2.default.createElement(
	      'section',
	      { className: _resourceLibrary.sectionStyle },
	      _react2.default.createElement(
	        _cards.Cards,
	        null,
	        nodes.slice(9).map(function (node) {
	          return _react2.default.createElement(NodeCard, { node: node, key: node.id });
	        })
	      )
	    ),
	    totalPages > 1 && _react2.default.createElement(_pagination.Pagination, {
	      initialPage: filters.page,
	      pageCount: totalPages,
	      onPageChange: function onPageChange(page) {
	        return _onPageChange(page);
	      } })
	  );
	};
	
	var nodePropType = _propTypes2.default.shape({
	  id: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  extract: _propTypes2.default.string,
	  date: _propTypes2.default.string,
	  categories: _propTypes2.default.object,
	  fields: _propTypes2.default.shape({
	    thumbnail_image: _propTypes2.default.shape({
	      childImageSharp: _propTypes2.default.shape({
	        resize: _propTypes2.default.shape({
	          src: _propTypes2.default.string.isRequired
	        }).isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    vimeo_url: _propTypes2.default.string
	  }))
	});
	
	NodeCard.propTypes = {
	  node: nodePropType
	};
	
	ResultsBlock.propTypes = {
	  data: _propTypes2.default.shape({
	    totalResources: _propTypes2.default.number.isRequired,
	    totalPages: _propTypes2.default.number.isRequired,
	    nodes: _propTypes2.default.arrayOf(nodePropType)
	  }),
	  page: _propTypes2.default.shape({
	    edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      node: _propTypes2.default.shape({
	        purple_heading: _propTypes2.default.string.isRequired,
	        purple_body: _propTypes2.default.string.isRequired,
	        button_text: _propTypes2.default.string.isRequired,
	        button_to: _propTypes2.default.string.isRequired
	      }).isRequired
	    })).isRequired
	  }).isRequired,
	  filters: _propTypes2.default.object,
	  onPageChange: _propTypes2.default.func.isRequired
	};

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(937);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SearchFilter = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _singleFieldForm = __webpack_require__(218);
	
	var _magnifyingGlassIcon = __webpack_require__(255);
	
	var _magnifyingGlassIcon2 = _interopRequireDefault(_magnifyingGlassIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchFilter = exports.SearchFilter = function SearchFilter(_ref) {
	  var placeholder = _ref.placeholder,
	      value = _ref.value,
	      _onChange = _ref.onChange,
	      _onSubmit = _ref.onSubmit;
	  return _react2.default.createElement(_singleFieldForm.SingleFieldForm, {
	    onSubmit: function onSubmit(e) {
	      e.preventDefault();
	      _onSubmit();
	    },
	    onChange: function onChange(e) {
	      return _onChange(e.target.value);
	    },
	    placeholderText: placeholder,
	    value: value,
	    buttonContent: _react2.default.createElement(_magnifyingGlassIcon2.default, null),
	    inputWidth: 404 });
	};
	
	SearchFilter.propTypes = {
	  placeholder: _propTypes2.default.string,
	  value: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired
	};

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(939);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InPagePrompt = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(9);
	
	var _styles = __webpack_require__(473);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InPagePromptComponent = function InPagePromptComponent(_ref) {
		var topText = _ref.topText,
		    bottomText = _ref.bottomText,
		    cta = _ref.cta,
		    inline = _ref.inline;
		return _react2.default.createElement(
			'div',
			{ className: (0, _styles.wrapperStyle)(inline) },
			_react2.default.createElement(
				'div',
				{ className: _styles.wrapperInnerStyle },
				_react2.default.createElement(
					'div',
					{ className: _styles.leftStyle },
					_react2.default.createElement(
						'p',
						{ className: _styles.topTextStyle },
						topText
					),
					_react2.default.createElement(
						'p',
						{ className: _styles.bottomTextStyle },
						bottomText
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _styles.rightStyle },
					_react2.default.createElement(
						_link.Link,
						{ to: cta.to, className: _styles.buttonStyle },
						_react2.default.createElement(
							'span',
							null,
							cta.text
						)
					)
				)
			)
		);
	};
	
	InPagePromptComponent.defaultProps = {
		inline: false
	};
	
	InPagePromptComponent.propTypes = {
		topText: _propTypes2.default.string,
		bottomText: _propTypes2.default.string,
		cta: _propTypes2.default.object,
		inline: _propTypes2.default.bool
	};
	
	var InPagePrompt = exports.InPagePrompt = InPagePromptComponent;

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(472);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.buttonStyle = exports.rightStyle = exports.leftStyle = exports.wrapperStyle = exports.bottomTextStyle = exports.topTextStyle = exports.wrapperInnerStyle = undefined;
	
	var _css2, _css3, _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperInnerStyle = /*#__PURE__*/exports.wrapperInnerStyle = (0, _emotion.css)({
		display: 'table',
		width: '100%',
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		margin: '0 auto'
	});
	
	var topTextStyle = /*#__PURE__*/exports.topTextStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
		margin: '0 0 15px 0',
		color: '#fff'
	}));
	
	var bottomTextStyle = exports.bottomTextStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		maxWidth: '720px',
		color: '#fff'
	}));
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(inline) {
		var _css;
	
		return (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)((_css = {
			display: 'table',
			width: '100%',
			backgroundColor: _globalStyles.purple,
			borderRadius: inline ? '8px' : '',
			padding: inline ? '16px 10px' : '40px 0'
		}, _css['& .' + topTextStyle] = inline ? {
			fontSize: '22px',
			fontWeight: 'normal'
		} : {
			fontSize: '36px',
			lineHeight: '36px'
		}, _css)));
	};
	
	//wrapperInnerStyle
	
	var leftStyle = /*#__PURE__*/exports.leftStyle = (0, _emotion.css)((_css2 = {
		padding: '20px'
	}, _css2['@media (min-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'table-cell'
	}, _css2));
	
	var rightStyle = /*#__PURE__*/exports.rightStyle = (0, _emotion.css)((_css3 = {
		padding: '20px',
		verticalAlign: 'middle'
	}, _css3['@media (min-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'table-cell'
	}, _css3));
	
	var buttonStyle = /*#__PURE__*/exports.buttonStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, (_extends2 = {
		background: _globalStyles.pink,
		display: 'block',
		textTransform: 'uppercase',
		color: '#fff',
		fontSize: '16px',
		lineHeight: '1',
		letterSpacing: '0.67px',
		padding: '18px 18px 14px 18px',
		textDecoration: 'none',
		borderRadius: '4px',
		position: 'relative'
	}, _extends2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		width: '100%'
	}, _extends2.textAlign = 'center', _extends2)));

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.mobileFiltersDropDownStyle = exports.mobileFiltersStyle = exports.innerWrapperStyle = exports.sectionStyle = exports.pageControlsStyle = exports.spacerStyle = exports.dropdownStyle = exports.formStyle = exports.navStyle = exports.navContainerStyle = exports.subTitleStyle = exports.titleStyle = exports.tabPageWrapper = exports.headerWrapperStyle = undefined;
	
	var _css, _css2, _css3, _css4, _css5, _css6;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var headerWrapperStyle = /*#__PURE__*/exports.headerWrapperStyle = (0, _emotion.css)((_css = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		paddingTop: '45px',
		'& > h1, & > div': {
			padding: '0 20px'
		}
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		paddingTop: '30px',
		'& h1': {
			marginBottom: '30px'
		}
	}, _css));
	
	var tabPageWrapper = /*#__PURE__*/exports.tabPageWrapper = (0, _emotion.css)((_css2 = {
		backgroundColor: '#F6F6F6',
		paddingTop: '36px'
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		paddingTop: 0
		//backgroundColor: '#fff',
	}, _css2));
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingXLarge, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '45px'
	}));
	
	var subTitleStyle = exports.subTitleStyle = (0, _emotion.cx)(_globalStyles.headingMedium, /*#__PURE__*/(0, _emotion.css)((_css3 = {}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '16px',
		lineHeight: '18px'
	}, _css3)));
	
	var navContainerStyle = /*#__PURE__*/exports.navContainerStyle = (0, _emotion.css)({
		position: 'sticky',
		top: '102px',
		zIndex: 3,
		background: '#fff'
	});
	
	var navStyle = /*#__PURE__*/exports.navStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		margin: '0 auto'
	});
	
	var formStyle = /*#__PURE__*/exports.formStyle = (0, _emotion.css)((_css4 = {
		marginBottom: '45px',
		display: 'flex',
		justifyContent: 'flex-start'
	
	}, _css4['@media (max-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		marginBottom: '30px',
		flexDirection: 'column',
		alignItems: 'stretch',
		'& input': {
			width: 'calc(100% - 46px)'
		}
	}, _css4));
	
	var dropdownStyle = /*#__PURE__*/exports.dropdownStyle = (0, _emotion.css)((_css5 = {
		width: 255,
		flex: '0 0 auto',
		marginRight: 16
	}, _css5['@media (max-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint + 'px)'] = {
		width: '100%',
		flexGrow: 1,
		marginRight: 0,
		marginBottom: 16
	}, _css5));
	
	var spacerStyle = /*#__PURE__*/exports.spacerStyle = (0, _emotion.css)({
		height: 43
	});
	
	var pageControlsStyle = /*#__PURE__*/exports.pageControlsStyle = (0, _emotion.css)((_css6 = {
		display: 'table',
		width: '100%',
		'& p': {
			display: 'table-cell',
			width: '100%',
			color: _globalStyles.darkGrey,
			fontSize: '16px',
			lineHeight: '19px'
		},
		'& > div': {
			display: 'table-cell'
		}
	}, _css6['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& p, & > div': {
			display: 'block'
		}
	}, _css6));
	
	var sectionStyle = exports.sectionStyle = (0, _globalStyles.cardSection)(60);
	
	var innerWrapperStyle = exports.innerWrapperStyle = _globalStyles.sideBarLayout.wrapper;
	
	var mobileFiltersStyle = exports.mobileFiltersStyle = _globalStyles.sideBarLayout.mobileFilters;
	
	var mobileFiltersDropDownStyle = exports.mobileFiltersDropDownStyle = _globalStyles.sideBarLayout.mobileFiltersDropDown;

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _qs = __webpack_require__(77);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _resourceLibraryManager = __webpack_require__(74);
	
	var _link = __webpack_require__(9);
	
	var _pageNav = __webpack_require__(27);
	
	var _audienceDropDown = __webpack_require__(930);
	
	var _landingBlock = __webpack_require__(936);
	
	var _resultsBlock = __webpack_require__(938);
	
	var _searchFilter = __webpack_require__(940);
	
	var _resourceLibrary = __webpack_require__(487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultFilters = { query: '', audience: '', type: '', page: 1 };
	
	var ResourceLibraryPage = function (_React$PureComponent) {
		_inherits(ResourceLibraryPage, _React$PureComponent);
	
		function ResourceLibraryPage() {
			var _this2 = this;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ResourceLibraryPage);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				loading: true,
				error: null,
				searchResults: {
					totalResources: 0,
					totalPages: 0,
					nodes: []
				},
				searchField: '',
				filters: defaultFilters
			}, _this.blockSearch = false, _this.componentDidMount = function () {
				_this.unlisten = _this.props.history.listen(_this.didChangeRoute); // eslint-disable-line
				_this.updateStateFromParams();
			}, _this.didChangeRoute = function () {
				if (!_this.blockSearch) {
					_this.updateStateFromParams();
				}
			}, _this.updateStateFromParams = function () {
				var params = _qs2.default.parse(location.search, { ignoreQueryPrefix: true });
				_this.setState({
					searchField: params.query || '',
					filters: _extends({}, defaultFilters, params)
				}, function () {
					_this.search(true);
				});
			}, _this.updateFilters = function (filter) {
				var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
				var preservePage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
				if (search) {
					_this.blockSearch = true;
				}
				_this.setState(function (prevState) {
					var filters = _extends({}, prevState.filters, filter, preservePage ? null : { page: 1 });
					return _extends({}, prevState, {
						filters: filters
					});
				}, function () {
					if (search) _this.search();
				});
			}, _this.updateQuery = function () {
				_this.setState(function (prevState) {
					var filters = _extends({}, prevState.filters, {
						query: prevState.searchField,
						page: 1
					});
					return _extends({}, prevState, {
						filters: filters
					});
				}, _this.search);
			}, _this.search = function (passive) {
				_this.setState(function (prevState) {
					return { loading: true, searchField: prevState.filters.query };
				}, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
					var base, queryParams, searchResults, results, parsed;
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.prev = 0;
	
									_this.blockSearch = true;
									base = location.hostname === 'localhost' ? 'http://localhost:9000' : '/.netlify/functions';
									queryParams = (0, _resourceLibraryManager.queryParamsFromFilters)(_this.state.filters);
	
	
									if (!passive) {
										// update the query string
										(0, _link.navigateTo)((0, _resourceLibraryManager.linkWithQueryParams)(queryParams));
									}
	
									searchResults = {
										totalResources: 0,
										totalPages: 0,
										nodes: []
									};
									// request data if filters aren't empty
	
									if (!(queryParams !== '')) {
										_context.next = 14;
										break;
									}
	
									_context.next = 9;
									return fetch(base + '/search-resource-library?' + queryParams);
	
								case 9:
									results = _context.sent;
									_context.next = 12;
									return results.json();
	
								case 12:
									parsed = _context.sent;
	
									searchResults = parsed;
	
								case 14:
	
									_this.setState({ loading: false, searchResults: searchResults });
									_this.blockSearch = false;
									_context.next = 23;
									break;
	
								case 18:
									_context.prev = 18;
									_context.t0 = _context['catch'](0);
	
									console.warn(_context.t0);
									_this.setState({ loading: false, error: _context.t0 });
									_this.blockSearch = false;
	
								case 23:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this2, [[0, 18]]);
				})));
			}, _this.areFiltersEmpty = function (filters) {
				return !filters.query && !filters.audience && !filters.type;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		ResourceLibraryPage.prototype.componentWillUnmount = function componentWillUnmount() {
			if (typeof this.unlisten === 'function') {
				this.unlisten();
			}
		};
	
		ResourceLibraryPage.prototype.render = function render() {
			var _this3 = this;
	
			var page = this.props.data.page;
			var _state = this.state,
			    loading = _state.loading,
			    searchField = _state.searchField,
			    filters = _state.filters,
			    searchResults = _state.searchResults;
	
			var shouldShowLandingPage = this.areFiltersEmpty(filters);
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: 'Resource Library' },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: 'InsideOut - Resource Library' })
				),
				_react2.default.createElement(
					'div',
					{ className: _resourceLibrary.headerWrapperStyle },
					_react2.default.createElement(
						'h1',
						{ className: _resourceLibrary.titleStyle },
						'Learn more about eating disorders'
					),
					_react2.default.createElement(
						'div',
						{ className: _resourceLibrary.formStyle },
						_react2.default.createElement(_audienceDropDown.AudienceDropDown, {
							value: filters.audience,
							onChange: function onChange(audience) {
								return _this3.updateFilters({ audience: audience, type: _resourceLibraryManager.categories[audience] ? _resourceLibraryManager.categories[audience][0] : '' }, true);
							},
							className: _resourceLibrary.dropdownStyle }),
						_react2.default.createElement(_searchFilter.SearchFilter, {
							placeholder: 'e.g. First symptoms of eating disorder',
							value: searchField,
							onChange: function onChange(query) {
								return _this3.setState({ searchField: query });
							},
							onSubmit: this.updateQuery })
					)
				),
				filters.audience && _react2.default.createElement(
					'div',
					{ className: _resourceLibrary.navContainerStyle },
					_react2.default.createElement(_pageNav.PageNav, {
						className: _resourceLibrary.navStyle,
						links: _resourceLibraryManager.categories[filters.audience].map(function (type) {
							return {
								to: (0, _resourceLibraryManager.linkWithQueryParams)((0, _resourceLibraryManager.queryParamsFromFilters)({ audience: filters.audience, type: type })),
								text: _resourceLibraryManager.typeTitles[type],
								managedKey: type
							};
						}),
	
						managed: {
							activeLink: filters.type,
							onClick: function onClick(type, e) {
								e.preventDefault();
								if (type === _this3.state.filters.type) return;
								_this3.updateFilters({ type: type }, true);
							}
						}
					})
				),
				!filters.audience && _react2.default.createElement('div', { className: _resourceLibrary.spacerStyle }),
				_react2.default.createElement(
					'div',
					{ className: _resourceLibrary.tabPageWrapper },
					_react2.default.createElement(
						'div',
						{ className: _resourceLibrary.innerWrapperStyle },
						loading && _react2.default.createElement(
							'p',
							null,
							'Loading...'
						),
						!loading && shouldShowLandingPage && _react2.default.createElement(_landingBlock.LandingBlock, { data: this.props.data, page: page, onSectionSelect: function onSectionSelect(section) {
								return _this3.updateFilters(section, true);
							} }),
						!loading && !shouldShowLandingPage && _react2.default.createElement(_resultsBlock.ResultsBlock, {
							data: searchResults,
							page: page,
							filters: filters,
							onPageChange: function onPageChange(page) {
								return _this3.updateFilters({ page: page }, true, true);
							} })
					)
				)
			);
		};
	
		return ResourceLibraryPage;
	}(_react2.default.PureComponent);
	
	ResourceLibraryPage.propTypes = {
		data: _propTypes2.default.object
	};
	exports.default = ResourceLibraryPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resource-library-index-js-49fcbbd7a00bafb8cd9f.js